// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3g1I_","bigColWidth":"Table_bigColWidth__1tQZB","biggerColWidth":"Table_biggerColWidth__2mNuF","row":"Table_row__6McqV","col":"Table_col__3tj17"};